module.exports = __webpack_public_path__ + "86659b6f4de04aba2beb336956ec40cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/1/Assets/day1.png
// module id = 1352
// module chunks = 0